module.exports = __webpack_public_path__ + "img/bre5.296057e8.png";